import { authedJson } from '../http';

export interface NotificationCounts {
  inbox_unread: number;
  actions_open: number;
  total: number;
}

export async function getNotificationCounts(): Promise<NotificationCounts> {
  return authedJson<NotificationCounts>('GET', '/api/v1/notifications/counts');
}
